import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import OperationDetailsService from "../../../../services/AuraCamera/operation-details/operation-details.service";
import Helpers from "../../../../utils/helpers";
import '../css/jm.css';

const LeakTab = (props: any) => {
  let RouteDetails = props.RouteDetails
  const [totalLeaks, setTotalLeaks] = useState<number>(0);
  const [siteName, setSiteName] = useState<string>("");
  const [SurveyDate, setSurveyDate] = useState<string>("");
  const [TabData, SetTabData] = useState<any>([]);

  const [AllKlvData, setAllKLVData] = useState([]);

  const [displayKLVinTable, setdisplayKLVinTable] = useState<any>([]);
  const session = window.localStorage;
  const [UnitPref, UpdateUnitPref] = useState<any>(
    session.getItem("UnitPrefWebApp")
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [VideoURL, setVideoURL] = useState("");
  const [Obs_Sequence, setObs_Sequence] = useState("");
  const [frameCount, setFrameCount] = useState(0);
  const [leakButton, setleakButton] = useState([]);
  const lkvideo = useRef<HTMLInputElement | any>(null);

  const handleLeakVideo = (media_location: any, klv_json_location: any) => {
    OperationDetailsService.GetKLV(klv_json_location).then((klv_data: any) => {
      setTimeout(() => {
        setAllKLVData(klv_data);

        setVideoURL(
          process.env.REACT_APP_BLOB_URL + media_location
        );
        setModalVisible(true);
      }, 1000);
    });
    lkvideo.current?.play();
  };
  useEffect(() => {

    // Test Start
    let final_output: any = [];



    RouteDetails?.map((route_values: any) => {
      route_values?.obs_sequence_targets?.map((obs_seq_val: any, obs_seq_ind: any) => {
        for (let x = 1; x <= obs_seq_val; x++) {
          props?.FilteredmapData && props?.FilteredmapData?.[0]?.routes?.map((mapping_route_val: any) => {
            if (mapping_route_val?.routeName == route_values?.routeName) {

              let temp_leak_details = mapping_route_val?.sequence?.[obs_seq_ind];
              let obs_lat = temp_leak_details?.lat;
              let obs_lon = temp_leak_details?.lon;
              let temp_leak_info: any = [];
              temp_leak_details?.leakDetails?.map((leak_info_val: any) => {
                if (leak_info_val?.target_sequence == `[${x}]`) {
                  temp_leak_info.push(leak_info_val);
                }
              });

              final_output?.push({
                Obs: obs_seq_ind + 1,
                Tar: x,
                route_name: route_values?.routeName,
                is_leak: (temp_leak_info?.length > 0) ? 'Leak Detected' : 'No Leak',
                leak_info: temp_leak_info,
                map_co: {
                  lat: obs_lat,
                  lon: obs_lon
                }
              });
            }
          })
        }
      })

    })
    SetTabData(final_output)

    // Test End
    let leak_Dates: any = [];

    let temp_total_leaks = 0;
    if (props?.FilteredmapData && props?.FilteredmapData[0]) {
      props.FilteredmapData[0]?.routes?.map((val: any) => {
        temp_total_leaks = val?.routeTotalleaks + temp_total_leaks;
      });
    }

    setTotalLeaks(temp_total_leaks);
    if (props?.FilteredmapData && props?.FilteredmapData[0]) {
      setSiteName(props?.FilteredmapData[0]?.siteName);
      setSurveyDate(props?.FilteredmapData[1]?.dateCreated);
    }

  }, [props]);
  useEffect(() => {
    // Update frame count on time updates
    const updateFrameCount = () => {
      // if (video) {
      UpdateUnitPref(session.getItem("UnitPrefWebApp"));

      const video: any = lkvideo.current;

      if (lkvideo.current != null) {
        const currentTime: any = video.currentTime;
        const duration = video.duration;
        const currentFrame = Math.floor(currentTime * frameRate);

        setFrameCount(currentFrame);
        setdisplayKLVinTable(AllKlvData[currentFrame]);
      }

      // }
    };

    // Set up interval timer to update frame count
    const intervalId = setInterval(updateFrameCount, 500); // Update every second

    return () => {
      clearInterval(intervalId); // Clean up interval on unmount
    };
  }, [AllKlvData]);
  const frameRate = 30; // Adjust this to your video's frame rate

  // console.log(TabData);

  return <>



    <Dialog
      header="Leak KLV Data"
      visible={modalVisible}
      modal={false}
      onHide={() => setModalVisible(false)}
      className="mapModal"
    >
      <div className="leakVideo">
        <div className="leakVideo-wrapper">
          <div className="leakVideo-wrapper__inner">
            <video ref={lkvideo} controls className="videoFile">
              <source src={VideoURL} type="video/mp4" />
              {/* <source src="/v1.mp4" type="video/mp4" /> */}
            </video>
          </div>
        </div>
        <div className="klvData-wrapper">
          <div className="klvData-wrapper__inner">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Field</th>
                  <th scope="col">Values</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Timestamp</th>
                  <td>
                    {Helpers.ConvertUtcToLocalReadableFullDate(
                      displayKLVinTable?.timestamp?.[0]
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Latitude</th>
                  {/* sensorLatitude */}
                  <td>
                    {displayKLVinTable?.sensorLatitude?.[0].toFixed(7)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Longitude</th>
                  <td>
                    {displayKLVinTable?.sensorLongitude?.[0].toFixed(7)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Air temperature</th>
                  <td>
                    {Helpers.UniteConversion(
                      UnitPref,
                      displayKLVinTable?.outsideAirTemperature?.[0].toFixed(1),
                      "temperature"
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Platform heading angle</th>
                  <td>
                    {displayKLVinTable?.platformHeadingAngle?.[0].toFixed(
                      1
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Platform pitch angle</th>
                  <td>
                    {displayKLVinTable?.platformPitchAngleFull?.[0].toFixed(1)}
                    {displayKLVinTable?.platformPitchAngle?.[0].toFixed(1)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Platform roll angle</th>
                  <td>
                    {displayKLVinTable?.platformPitchRollFull?.[0].toFixed(1)}
                    {displayKLVinTable?.platformRollAngle?.[0].toFixed(1)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Altitude </th>
                  <td>
                    {displayKLVinTable?.sensorTrueAltitude?.[0].toFixed(1)}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Wind speed</th>
                  <td>
                    {Helpers.UniteConversion(
                      UnitPref,
                      displayKLVinTable?.windSpeed?.[0].toFixed(1),
                      "wind_speed"
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Ground range</th>
                  <td>
                    {Helpers.UniteConversion(
                      UnitPref,
                      displayKLVinTable?.groundRange?.[0].toFixed(0),
                      "ground_range"
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Fuel remains</th>
                  <td>{displayKLVinTable?.platformFuelRemaining?.[0]}</td>
                </tr>
                <tr>
                  <th scope="row">Pitch angle</th>
                  <td>
                    {displayKLVinTable?.platformPitchAngleFull?.[0].toFixed(
                      1
                    )}
                  </td>
                </tr>
                <tr>
                  <th scope="row">Pitch roll</th>
                  <td>
                    {displayKLVinTable?.platformPitchRollFull?.[0].toFixed(
                      1
                    )}
                  </td>
                </tr>
                {/* <tr>
                    <th scope="row">checksum</th>
                    <td>{displayKLVinTable?.checksum}</td>
                  </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Dialog>
    <div style={{
      height: "550px",
      margin: "0em",
      overflow: "scroll",
      scrollbarWidth: 'thin'
    }}>
      <div className="table-responsive">
        <table className="w-full mapLeakDataTab">
          <thead className="bg-white border border-gray-400 sticky top-0 z-2 border-collapse" style={{ height: '50px' }}>
            <tr className="bg-gray-300">
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span> Route </span>
                  </div>
                </div>
              </th>
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span> Observation Points </span>
                  </div>

                </div>
              </th>
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span>Coordinates</span>
                  </div>
                </div>
              </th>
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span>Target</span>
                  </div>
                </div>
              </th>
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span>Leak/No Leak</span>
                  </div>
                </div>
              </th>
              <th className="p-1 text-sm text-left font-normal border" style={{ background: "#dededd", width: "10%", textAlign: 'center' }}>
                <div className="flex items-center">
                  <div className="flex-grow pl-1">
                    <span>Leak Details</span>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {
              TabData?.length > 0 ?
                TabData.map((val: any, index: any) => (
                  val?.Tar !== 1 ?
                    <tr key={index}>
                      <td className="px-2 py-2 text-xs" style={{ textAlign: 'center' }}>{val?.route_name}</td>
                      <td className="px-2 py-2 text-xs" style={{ textAlign: 'center' }}>{`Observation ${val?.Obs}`}</td>
                      <td className="px-2 py-2 text-xs" style={{ textAlign: 'center' }}>{`${Number(val?.map_co?.lat).toFixed(6)},`}<br />{Number(val?.map_co?.lon).toFixed(6)}</td>
                      <td className="px-2 py-2 text-xs" style={{ textAlign: 'center' }}>{val?.Tar}</td>
                      <td className="px-2 py-2 text-xs" style={{ textAlign: 'center' }}>{val?.is_leak}</td>
                      <td className="px-2 py-2 text-xs" style={{ minWidth: '170px', textAlign: 'center' }}>
                        {(val?.is_leak == "No Leak") ? "No Leak Data to Display" :
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              handleLeakVideo(
                                val?.leak_info?.[0]?.mp4_location
                                ,
                                val.leak_info?.[0]?.klv_json
                              );
                              // handle KLV Api
                            }}
                          >
                            {`View`}
                          </button>
                        }
                      </td>
                    </tr> : ''
                )) :
                <></>
            }
          </tbody>
        </table>
        {/* <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <h5>No data Found !</h5>
        </div> */}
      </div>
    </div>
  </>
}

export default LeakTab;